// packages/shared/src/map/minimap.ts — RGBA pixels for the founding/invite plot pickers (DESIGN.md world palette)
import type { GenObject, MapData } from '../types/map';
import { groundAt, tierAt } from './codec';

const hex = (h: string): [number, number, number] => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
const SEA_DEEP = hex('#2A7E98'), SEA_SHELF = hex('#7EC6BE'), SAND = hex('#E8D29C'), WATER = hex('#5CC6D4'), PATH = hex('#EFE6CC'), CLIFF = hex('#B78C60');
const TIERS = [hex('#E8D29C'), hex('#86C873'), hex('#7CBE6B'), hex('#90CE7E')];
const RAMP = hex('#A0D78C'), TREE = hex('#3F8F55'), FRUIT = hex('#F6A57E'), ROCK = hex('#D9D0BE'), BUILDING = hex('#C84B30'), BRIDGE = hex('#C9A274'), OTHER = hex('#7A5A3E');

export function minimapRGBA(map: MapData, objects: readonly GenObject[]): Uint8ClampedArray {
  const px = new Uint8ClampedArray(map.w * map.h * 4);
  const put = (x: number, y: number, c: readonly [number, number, number]) => { const i = (y * map.w + x) * 4; px[i] = c[0]; px[i + 1] = c[1]; px[i + 2] = c[2]; px[i + 3] = 255; };
  const nearLand = (x: number, y: number) => {
    for (let dy = -2; dy <= 2; dy++) for (let dx = -2; dx <= 2; dx++) { const g = groundAt(map, x + dx, y + dy); if (g !== 'sea') return true; }
    return false;
  };
  for (let y = 0; y < map.h; y++) for (let x = 0; x < map.w; x++) {
    const g = groundAt(map, x, y);
    put(x, y, g === 'sea' ? (nearLand(x, y) ? SEA_SHELF : SEA_DEEP) : g === 'sand' ? SAND : g === 'river' || g === 'pond' ? WATER
      : g === 'path' ? PATH : g === 'cliff' ? CLIFF : g === 'ramp' ? RAMP : TIERS[tierAt(map, x, y)]!);
  }
  for (const o of objects) {
    const c = o.catalogId === 'w.tree_fruit' ? FRUIT : o.kind === 'tree' ? TREE : o.kind === 'rock' ? ROCK : o.kind === 'building' ? BUILDING : o.kind === 'bridge' ? BRIDGE : OTHER;
    put(o.x, o.y, c);
  }
  return px;
}
